export const mixinNumbers = {
  computed: {
    numberLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    currencyFormat(numb, curr){
      let res;
      // fixing decimals
      if(typeof numb == 'number'){
        res = parseFloat(numb.toFixed(2))
      } else if(typeof numb == 'string'){
        const val = parseFloat(numb)
        if(Number.isNaN(val)){
          res = ''
        } else {
          res = parseFloat(numb).toFixed(2)
        }
      } else {
        res = ''
      }

      // adding currency according to language 
      if(this.numberLocale == 'es'){
        res = this.completeWithZero(this.formatLanguageNumber(res)) + '\xa0' + curr
      } else {
        res = curr + '\xa0' + this.completeWithZero(this.formatLanguageNumber(res))
      }
      // the space format as '\xa0' instead ' ' is because html do not break the word
      return res;
    },
    formatLanguageNumber(numb, lang){
      if(lang == undefined){
        lang = this.numberLocale;
      }
      if(lang == 'es'){
        return numb.toString().replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return numb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    completeWithZero(val, lang){
      if(lang == undefined){
        lang = this.numberLocale;
      }
      let decimals;
      if(lang == 'es'){
        decimals = val.split(',')[1];
        if (decimals == undefined){
          return val + ',00';
        } else if(decimals.length == 1){
          return val + '0';
        } else {
          return val
        }
      } else {
        decimals = val.split('.')[1];
        if (decimals == undefined){
          return val + '.00';
        } else if(decimals.length == 1){
          return val + '0';
        } else {
          return val
        }
      }
    },
  }
};
